"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _Elements = require("./Elements");

var SvgIcon = function SvgIcon(_ref) {
  var src = _ref.src,
      size = _ref.size,
      fill = _ref.fill,
      alignLeft = _ref.alignLeft,
      className = _ref.className,
      as = _ref.as;
  return /*#__PURE__*/_react["default"].createElement(_Elements.IconWrapper, {
    as: as,
    size: size,
    fill: fill,
    alignLeft: alignLeft,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: src,
    cacheRequests: true,
    uniquifyIDs: true
  }));
};

SvgIcon.defaultProps = {
  alignLeft: false,
  size: null,
  className: null,
  as: 'div',
  fill: null
};
SvgIcon.propTypes = {
  alignLeft: _propTypes["default"].bool,
  size: _propTypes["default"].string,
  src: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  as: _propTypes["default"].string,
  fill: _propTypes["default"].string
};
var _default = SvgIcon;
exports["default"] = _default;